<template>
  <div>
    <!-- <div class="left-div">
      <img alt="宇罡科技" src="../../assets/logo-1.png" style="width:100px;height:100px;margin-top:50px;" />
      <p style="margin-top:30px;font-size:32px;color:#000;font-weight:bold;">浅集云码</p>
      <p style="margin-top:30px;font-size:28px;color:#000;font-weight:bold;">防伪溯源 智慧管理</p>
    </div> -->
    <div class="logo"></div>
    <div class="user-layout-login">
      <p style="color:#2A3954;text-align:center;font-size:20px;padding-top:25px;padding-bottom:10px;">欢迎登录</p>
      <a-form id="formLogin" ref="formLogin" :form="form" @submit="handleSubmit">
        <!-- 请输入客户编号 -->
        <!-- <a-form-item>
          <a-input
            class="login-input"
            size="large"
            type="text"
            placeholder="请输入客户编号"
            v-decorator="[
              'tenantCode',
              { rules: [{ required: true, message: '请输入客户编号' }], validateTrigger: 'change' }
            ]"
          >
            <a-icon slot="prefix" type="smile" :style="{ color: '#7F8A9D', 'font-size': '22px' }" />
          </a-input>
        </a-form-item> -->
        <!-- 账户名 -->
        <a-form-item>
          <a-input
            class="login-input"
            size="large"
            type="text"
            placeholder="请输入帐号"
            v-decorator="[
              'account',
              { rules: [{ required: true, message: '请输入帐号' }], validateTrigger: 'change' }
            ]"
          >
            <!-- <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" /> -->
            <div slot="prefix" class="account-icon" />
          </a-input>
        </a-form-item>

        <!-- 密码 -->
        <a-form-item>
          <a-input
            class="login-input"
            size="large"
            type="password"
            autocomplete="false"
            placeholder="请输入密码"
            v-decorator="['password', { rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur' }]"
          >
            <!-- <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" /> -->
            <div slot="prefix" class="passage-icon" />
          </a-input>
        </a-form-item>

        <!-- 验证码 -->
        <!-- <a-row :gutter="16">
          <a-col class="gutter-row" :span="15">
            <a-form-item>
              <a-input
                size="large"
                type="text"
                placeholder="请输入验证码"
                v-decorator="[
                  'captcha',
                  { rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur' }
                ]"
              >
                <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }" />
              </a-input>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="9">
            <img
              style="cursor:pointer;width:100px;height:40px;"
              title="点击刷新验证码"
              :src="'/merchant.php/user/getCodePic?v=' + codeTimestamp"
              @click="refreshCode()"
            />
          </a-col>
        </a-row> -->

        <!-- 确定 -->
        <a-form-item style="margin:30px 0 50px;">
          <a-button
            size="large"
            type="primary"
            htmlType="submit"
            class="login-button"
            :loading="state.loginBtn"
            :disabled="state.loginBtn"
          >登&nbsp;&nbsp;录</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'

export default {
  components: {},
  data() {
    return {
      loginBtn: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false
      },
      codeTimestamp: ''
    }
  },
  created() {},
  methods: {
    refreshCode() {
      this.codeTimestamp = new Date().getTime()
    },
    ...mapActions(['Login', 'Logout']),
    handleSubmit(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        Login
      } = this

      state.loginBtn = true

      const validateFieldsKey = ['tenantCode', 'account', 'password', 'captcha']

      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          console.log('login form', values)
          const params = {
            tenantCode: values.tenantCode,
            account: values.account,
            code: values.captcha,
            password: values.password
          }
          Login(params)
            .then((res) => {
              if (_.get(res, 'code') === 200) {
                this.loginSuccess(res)
              }
            })
            .catch((err) => console.log(err))
            .finally(() => {
              state.loginBtn = false
            })
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    loginSuccess(res) {
      this.$router.push({ path: '/' })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
    },
    requestFailed(err) {
      this.$notification['error']({
        message: '错误',
        description: err.message || '请求出现错误，请稍后再试',
        duration: 4
      })
    }
  }
}
</script>

<style lang="less" scoped>
.logo{
  width: 300px;
  height: 70px;
  background-image: url('../../assets/images/logo.png');
  background-size: 100% 100%;
  margin: 0 auto 50px;
}
.user-layout-login {
  background: #d8d8d8a6;
  color: #fff;
  padding: 0 60px;
  width: 375px;
  margin: 0 auto;
  border-radius: 10px;
  overflow: hidden;
  label {
    font-size: 14px;
  }
  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    font-size: 20px;
    height: 40px;
    width: 255px;
    background: #A3AABA;
    border-color: #A3AABA;
    border-radius: 20px;
    // box-shadow: 0px 0px 10px 0px #A3AABA;
    color: #2A3953;
  }
  .account-icon{
    width: 22px;
    height: 22px;
    background-image: url('../../assets/images/user.png');
    background-size: 100% 100%
  }
  .passage-icon{
    width: 22px;
    height: 22px;
    background-image: url('../../assets/images/passage.png');
    background-size: 100% 100%
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
  /deep/.ant-input-affix-wrapper .ant-input {
    text-align: center;
    border: none;
    border-radius: 20px;
    overflow: hidden;
    background-color: #2A3953;
    background-clip: content-box;
    color: #fff;
    padding: 0
  }
</style>
